import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostBinding,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rd-shared-fulfillment-processing-loader',
  templateUrl: './fulfillment-processing-loader.component.html',
  styleUrls: ['./fulfillment-processing-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FulfillmentProcessingLoaderComponent implements AfterViewInit {
  @HostBinding('class.rd-shared-fulfillment-processing-loader')
  componentClass = true;

  constructor(
    private liveAnnouncer: LiveAnnouncer,
    private translateService: TranslateService,
  ) {}

  ngAfterViewInit(): void {
    this.liveAnnouncer.announce(
      this.translateService.instant('fulfillment.processing'),
    );
  }
}
